import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../../context/AuthContext";
import config from "../../config";
import { Row, Col, Card, Breadcrumb, Form } from 'react-bootstrap';
import GifLoder from '../../components/GifLoder';
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Checkbox } from "primereact/checkbox";
import { InputTextarea } from 'primereact/inputtextarea';
import crossVideo from '../../assets/video/cross.mp4';
import { Dialog } from "primereact/dialog";
import { IoChevronBackOutline } from "react-icons/io5";

const Client_Form_edit = () => {
    const { accessToken } = useAuth();
    const { form_id } = useParams(); // Get form_id from URL
    const navigate = useNavigate();

    const [videocrossDialogVisible, setVideocrossDialogVisible] = useState(false); // New state for video dialog


    const [form, setForm] = useState({
        form_name: "",
        description: "",
        form_categories_id: "",
        sections: [],
    });

    const [loading, setLoading] = useState(true);

    const [currentStep, setCurrentStep] = useState(1);
    const availableSteps = [...new Set(form.sections.map(section => section.step))].sort((a, b) => a - b);

    const findNextStep = (current) => availableSteps.find(step => step > current) || null;
    const findPreviousStep = (current) => [...availableSteps].reverse().find(step => step < current) || null;

    // Fetch form details
    useEffect(() => {
        const fetchForm = async () => {
            try {
                const response = await axios.get(
                    `${config.apiBASEURL}/ClientFormRoutes/fetch-specific-form/${form_id}`,
                    { headers: { Authorization: `Bearer ${accessToken}` } }
                );
                if (response.status === 200) {
                    setForm(response.data);
                }
            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchForm();
    }, [form_id, accessToken]);


    // Handle input changes
    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    // Handle section name change
    const handleSectionChange = (secIndex, e) => {
        const { name, value } = e.target;
        const updatedSections = [...form.sections];

        // Convert step value to a number
        updatedSections[secIndex][name] = name === "step" ? Number(value) : value;

        setForm({ ...form, sections: updatedSections });
    };

    // Handle field changes inside a section
    const handleFieldChange = (sectionIndex, fieldIndex, name, value) => {
        const updatedSections = [...form.sections];
        updatedSections[sectionIndex].fields[fieldIndex] = {
            ...updatedSections[sectionIndex].fields[fieldIndex],
            [name]: value,
        };
        setForm({ ...form, sections: updatedSections });
    };

    // Add new section
    const addSection = () => {
        setForm(prevForm => {
            const maxStep = prevForm.sections.length > 0
                ? Math.max(...prevForm.sections.map(section => section.step))
                : 0; // Start from step 1 if no sections

            return {
                ...prevForm,
                sections: [
                    ...prevForm.sections,
                    {
                        section_name: "",
                        step: maxStep + 1,  // Incrementing the step
                        is_repeatable: false,
                        fields: []
                    }
                ]
            };
        });
    };

    // Delete section
    const deleteSection = (index) => {
        const updatedSections = [...form.sections];
        updatedSections.splice(index, 1);
        setForm({ ...form, sections: updatedSections });
    };

    // Add new field in a section
    const addField = (sectionIndex) => {
        const updatedSections = [...form.sections];
        updatedSections[sectionIndex].fields.push({
            field_label: "",
            field_name: "",
            input_type: "text", // Default input type
            options: "", // Default options
            is_required: false, // Default is_required
        });
        setForm({ ...form, sections: updatedSections });
    };

    // Delete field
    const deleteField = (sectionIndex, fieldIndex) => {
        const updatedSections = [...form.sections];
        updatedSections[sectionIndex].fields.splice(fieldIndex, 1);
        setForm({ ...form, sections: updatedSections });
    };


    // Submit updated form
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const updatedSections = [...form.sections];

            // Validation: Ensure all sections have required fields
            for (const section of updatedSections) {
                if (!section.section_name || section.step === undefined) {
                   
                    setLoading(false);
                    return;
                }

                for (const field of section.fields || []) {
                    if (!field.field_label || !field.field_name || !field.input_type) {
                       
                        setLoading(false);
                        return;
                    }
                }
            }

            // Sort sections by current step
            updatedSections.sort((a, b) => a.step - b.step);

            // Track assigned steps
            let currentStep = 1;

            // Assign sequential steps
            for (let i = 0; i < updatedSections.length; i++) {
                if (i === 0 || updatedSections[i].step !== updatedSections[i - 1].step) {
                    updatedSections[i].step = currentStep;
                    currentStep++;
                } else {
                    // Keep the same step for duplicates
                    updatedSections[i].step = updatedSections[i - 1].step;
                }
            }

            await axios.put(
                `${config.apiBASEURL}/ClientFormRoutes/edit-form/${form_id}`,
                { ...form, sections: updatedSections },
                { headers: { Authorization: `Bearer ${accessToken}` } }
            );

            navigate("/Graphe/dashboard/onboarding_formlist"); // Redirect to forms list page
        } catch (err) {
            console.error("Error updating form:", err);
            setLoading(false); // Stop loading
            setVideocrossDialogVisible(true); // Show video dialog

            setTimeout(() => {
                setVideocrossDialogVisible(false); // Hide video dialog after 6 seconds

            }, 5000);
        } finally {
            setLoading(false);
        }
    };

    const goBack = () => {
        navigate(-1); // This will take the user back to the previous page in history
    };

    return (
        <>
            {loading ? (
                <div className="loderDiv">
                    <GifLoder />
                </div>
            ) : (
                <Row className='body_content'>
                    <Row className='mx-0'>
                        <Col md={12} lg={12} className='mb-4 d-flex justify-content-between align-items-center'>
                            <Breadcrumb>
                                <Breadcrumb.Item onClick={goBack}>
                                    <IoChevronBackOutline /> Back
                                </Breadcrumb.Item>
                                <Breadcrumb.Item active>Client Form Preview</Breadcrumb.Item>
                            </Breadcrumb>
                        </Col>

                        <Col lg={12} className="">
                            <Row className="mx-0">
                                {/* Form Creation Section */}
                                <Col lg={7} md={8}>
                                    <Card className="p-0 shadow-sm">
                                        <Card.Header className="h6">Edit Form</Card.Header>
                                        <Form onSubmit={handleSubmit}>
                                            <Card.Body>
                                                <Row className="align-items-end">
                                                    <Col md={6} lg={6} className="mb-3">
                                                        <label className="mb-2">Form Name:</label>
                                                        <InputText value={form.form_name} onChange={handleChange} required />
                                                    </Col>
                                                    <Col md={6} lg={6} className="mb-3">
                                                        <label>Category:</label>
                                                        <InputText value={form.category.type}
                                                            onChange={handleChange}
                                                            disabled />

                                                    </Col>
                                                    <Col md={6} lg={12} className="mb-3">
                                                        <label className="mb-2">Description:</label>
                                                        <InputTextarea value={form.description} onChange={handleChange} />
                                                    </Col>
                                                </Row>

                                                {form.sections.map((section, secIndex) => (

                                                    <div key={secIndex} className="allempList mt-3 oddevenRow">
                                                        <div className="rol-title">
                                                            Form Section (Page - {section.step})
                                                        </div>
                                                        <Row>
                                                            <Col md={6} lg={8} className="mb-3">
                                                                <InputText
                                                                    name="section_name"
                                                                    placeholder="Section Name"
                                                                    value={section.section_name}
                                                                    onChange={(e) => handleSectionChange(secIndex, e)}
                                                                    required
                                                                />
                                                            </Col>
                                                            <Col md={6} lg={4} className="mb-3 d-flex justify-content-end align-items-center">
                                                                <label className="me-3" style={{ width: '80px' }}>Page :</label>
                                                                <InputText
                                                                    name="step"
                                                                    type="number"
                                                                    min="1"
                                                                    value={section.step}
                                                                    onChange={(e) => handleSectionChange(secIndex, e)}
                                                                />
                                                            </Col>
                                                            <Col md={6} lg={6} className="mb-3">
                                                                <label>
                                                                    <Checkbox
                                                                        checked={section.is_repeatable}
                                                                        onChange={(e) =>
                                                                            handleSectionChange(secIndex, {
                                                                                target: {
                                                                                    name: "is_repeatable",
                                                                                    value: e.target.checked,
                                                                                },
                                                                            })
                                                                        }
                                                                        className="me-3"
                                                                    />
                                                                    Is Section Repeatable

                                                                </label>
                                                            </Col>
                                                            <Col md={6} lg={6} className="mb-3 text-end">
                                                                <Button
                                                                    type="button"
                                                                    onClick={() => addField(secIndex)}
                                                                    title="Field"
                                                                    icon="pi pi-plus"
                                                                    text
                                                                    className="p-0"
                                                                    severity="help"
                                                                />
                                                                <Button
                                                                    type="button"
                                                                    className="p-0"
                                                                    onClick={() => deleteSection(secIndex)}
                                                                    title="Delete"
                                                                    icon="pi pi-trash"
                                                                    text
                                                                    severity="danger"

                                                                />
                                                            </Col>
                                                        </Row>

                                                        {section.fields.map((field, fieldIndex) => (
                                                            <Row key={fieldIndex} className="align-items-center child_row">
                                                                <Col md={6} lg={6} className="mb-3">
                                                                    <InputText
                                                                        placeholder="Field Label"
                                                                        value={field.field_label}
                                                                        onChange={(e) => handleFieldChange(secIndex, fieldIndex, "field_label", e.target.value)}
                                                                    />
                                                                </Col>
                                                                <Col md={6} lg={6} className="mb-3">
                                                                    <InputText
                                                                        placeholder="Field Name"
                                                                        value={field.field_name}
                                                                        onChange={(e) => handleFieldChange(secIndex, fieldIndex, "field_name", e.target.value)}
                                                                    />
                                                                </Col>
                                                                <Col md={6} lg={6} className="mb-3">
                                                                    <Dropdown
                                                                        value={field.input_type}
                                                                        options={[{ label: 'Text', value: 'text' }, { label: 'Number', value: 'number' }, { label: 'Email', value: 'email' }, { label: 'Date', value: 'date' }, { label: 'Textarea', value: 'textarea' }, { label: 'Select', value: 'select' }]}
                                                                        onChange={(e) => handleFieldChange(secIndex, fieldIndex, "type", e.value)}
                                                                    />
                                                                </Col>
                                                                {field.type === 'select' && (
                                                                    <Col md={6} lg={6} className="mb-3">
                                                                        <InputText
                                                                            placeholder="Options (comma-separated)"
                                                                            value={field.options}
                                                                            onChange={(e) => handleFieldChange(secIndex, fieldIndex, "options", e.target.value)}
                                                                        />

                                                                    </Col>
                                                                )}
                                                                <Col md={6} lg={6} className="mb-3 d-flex justify-content-between align-items-center">
                                                                    <label>
                                                                        <Checkbox
                                                                            checked={field.is_required}
                                                                            onChange={(e) => handleFieldChange(secIndex, fieldIndex, "is_required", e.checked)}
                                                                            className="me-3"
                                                                        />
                                                                        Required

                                                                    </label>

                                                                    <Button
                                                                        type="button"
                                                                        className="p-0 child_deliterow"
                                                                        onClick={() => deleteField(secIndex, fieldIndex)}
                                                                        title="Delete"
                                                                        icon="pi pi-times"
                                                                        text
                                                                        severity="danger"
                                                                    />

                                                                </Col>

                                                            </Row>
                                                        ))}
                                                    </div>
                                                ))}

                                            </Card.Body>
                                            <Card.Footer className="d-flex justify-content-end align-items-center px-2">
                                                <Button
                                                    type="button"
                                                    onClick={addSection}
                                                    label="Section"
                                                    icon="pi pi-plus"
                                                    className="py-2 me-2"
                                                    severity="primary"
                                                />
                                                <Button
                                                    type="submit"
                                                    label="Save"
                                                    icon="pi pi-save"
                                                    className="py-2 me-2"
                                                    severity="success"
                                                />
                                            </Card.Footer>
                                        </Form>
                                    </Card>
                                </Col>

                                {/* Form Preview Section */}
                                <Col lg={5} md={4}>
                                    <Card className="p-0 shadow-sm h-auto sticky-top">
                                        <Card.Header className="h6">Demo Preview</Card.Header>
                                        <Card.Body>
                                            <h5 className="mb-0">{form.form_name || "Form Title"}</h5>
                                            <p className="mb-4 text-secondary">
                                                <small>{form.description || "Form description will appear here."}</small>
                                            </p>

                                            {/* Ensure we are correctly rendering sections for the current step */}
                                            {form.sections.filter(section => section.step === currentStep).length > 0 ? (
                                                <div className="rightFormdydata">
                                                    {form.sections
                                                        .filter(section => section.step === currentStep)
                                                        .map((section, secIndex) => (
                                                            <div key={secIndex} className="mb-3">
                                                                <h6>{section.section_name || `Section ${secIndex + 1}`}</h6>
                                                                <ul>
                                                                    {section.fields.map((field, i) => (
                                                                        <li key={i}>
                                                                            <label>
                                                                                {field.field_label}{" "}
                                                                                <span className="text-danger">{field.is_required && '*'}</span>
                                                                            </label>
                                                                            {field.input_type === "select" ? (
                                                                                <select disabled>
                                                                                    {field.options.split(",").map((option, idx) => (
                                                                                        <option key={idx} value={option.trim()}>
                                                                                            {option.trim()}
                                                                                        </option>
                                                                                    ))}
                                                                                </select>
                                                                            ) : (
                                                                                <input type={field.input_type} disabled />
                                                                            )}
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                            </div>
                                                        ))}
                                                </div>
                                            ) : (
                                                <p>No sections available for this step.</p>
                                            )}

                                            <div className="step-navigation d-flex justify-content-end align-items-center mt-4">
                                                <Button
                                                    type="button"
                                                    onClick={() => setCurrentStep(prev => findPreviousStep(prev))}
                                                    disabled={findPreviousStep(currentStep) === null}
                                                    className="py-2 me-2"
                                                    title="Previous"
                                                    icon="pi pi-angle-left"
                                                />

                                                {findNextStep(currentStep) !== null ? (
                                                    <Button
                                                        type="button"
                                                        onClick={() => setCurrentStep(prev => findNextStep(prev))}
                                                        className="py-2"
                                                        title="Next"
                                                        icon="pi pi-angle-right"
                                                    />
                                                ) : (
                                                    <Button
                                                        type="button"
                                                        label="Submit"
                                                        className="py-2"
                                                        severity="success"
                                                        title="Submit"
                                                        disabled
                                                    />
                                                )}
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col>


                            </Row>
                        </Col>
                        <Dialog visible={videocrossDialogVisible} className='fadeInUp_dilog'
                            onHide={() => setVideocrossDialogVisible(false)} style={{ width: '320px' }} closable={false}>
                            <video src={crossVideo} autoPlay loop muted style={{ width: '100%' }} />
                            <h6 className="text-center mt-0 fadeInUp">Process <span className='text-danger'>Denied</span></h6>
                        </Dialog>
                    </Row >
                </Row >

            )}
        </>
    );
};
export default Client_Form_edit;
